import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// react - i18next 與 i18next 為必備的核心套件。i18next -
// http - backend 則是能夠讓語言檔透過 XMLHttpRequest 或 the fetch API 來載入，非常推薦使用。

export default i18n
  .use(Backend)
  /** 偵測瀏覽器語言 */
  .use(LanguageDetector)
  // react-i18next 與 i18next 為必備的核心套件
  .use(initReactI18next)
  .init({
    // backend: {
    //   loadPath: 'http://localhost:3001/i18n',
    // },
    // 預設語言
    lng: 'zh-tw',
    // 當目前的語言檔找不到對應的字詞時，會用 fallbackLng  作為預設語言
    // 如果連 fallbackLng 都沒有，就會顯示name(如："title.default")
    fallbackLng: 'zh-tw',
    // F12會有log
    debug: false,
    react: {
      useSuspense: false, // 不加會有錯
    },
    interpolation: {
      // 是否要讓字詞 escaped 來防止 xss 攻擊，這裡因為 React.js 已經做了，就設成 false即可
      // 如果語系檔中有巢狀的結構，則 escapeValue 要設為 false，這樣就可以透過物件的方式來取得巢狀內的翻譯
      escapeValue: false,
    },
  });
